import { useEffect } from "react";
import getAncestors from "../../components/drops/mixins/getAncestors";
export default (function (targetRef, onClickOutside) {
    return useEffect(function () {
        if (!onClickOutside)
            return;
        var onMousedown = function (event) {
            if (event.target !== targetRef.current &&
                !getAncestors(event.target).some(function (node) { return node === targetRef.current; })) {
                onClickOutside(event);
            }
        };
        document.addEventListener("mousedown", onMousedown);
        return function () { return document.removeEventListener("mousedown", onMousedown); };
    }, [onClickOutside]);
});
